import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

export const BILLING_SUBSCRIPTIONS_QUERY = gql`
  query BillingSubscriptions($businessEntityUuid: UUID!) {
    billingSubscriptions(businessEntityUuid: $businessEntityUuid) {
      active {
        orderBillingItemUuid
        service
        subscriptionStatus
        summary
        price
        period
        inTrial
        trialDays
        termStartDate
        termEndDate
        cancelDate
        contractInterval
        isFormationComplete
        isPostPurchaseComplete
        titleMessageId
        benefitMessageIds
        includes {
          orderBillingItemUuid
        }
        payment {
          paymentStatus
        }
        benefits {
          label
          description
        }
        customerActions {
          doNotRenew {
            allowed
            reasons
          }
          undoDoNotRenew {
            allowed
            reasons
          }
          cancelTrial {
            allowed
            reasons
          }
          resumeTrial {
            allowed
            reasons
          }
        }
      }
      errorStatus
    }
  }
`;

export function useBillingSubscriptions({ skipCache = false } = {}) {
  const { businessEntityUuid } = useBusinessEntity();

  const { data, loading, error } = useQuery(BILLING_SUBSCRIPTIONS_QUERY, {
    noThrow: true,
    skip: !businessEntityUuid,
    variables: { businessEntityUuid },
    skipCache,
  });

  useError(error);

  return {
    data: data?.billingSubscriptions?.active || [],
    loading,
    hasError: Boolean(error),
  };
}
